import * as React from 'react';
import * as styles from './ContentOrganizerConfigPanel.css';
import { ContentOrganizerStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { LocalizationService } from "./../../../services/LocalizationService";
import { IAToggle } from '../../toggle/Toggle';
import { IANumberField } from '../../numberField/NumberField';
// import { IAPeopleSearch } from '../../peopleSearch/PeopleSearch';
// import { IUser } from '../../../interfaces/IUser';
import { TargetingService } from '../../../services/TargetingService';
import { ITermResult } from '../../../interfaces/ITermResult';
import { IADropDown } from '../../dropDown/DropDown';
import { IAMultiSelectDropDown } from '../../multiSelectDropDown/MultiSelectDropDown';
import ContentOrganizerService from '../../../services/ContentOrganizerService';
import { IDocumentLibrary, IDocumentLibraryOption } from '../../../interfaces/IDocumentLibrary';
import { IMultiSelectDropDownOption } from '../../multiSelectDropDown/MultiSelectDropDown';
import { IASpinner } from '../../spinner/Spinner';

export interface IContentOrganizerConfigPanelProps {
  contentOrganizerStore?: ContentOrganizerStore;
  storeInitializationComplete: boolean;
  beforeIaReady: () => void;
  afterIaReady: () => void;
  onSelectedStep: (step) => void;
}

export interface IContentOrganizerConfigPanelState {
  terms: ITermResult[];
  termsList: any[];
  documentLibraries: IDocumentLibraryOption[];
  isLoading: boolean;
}

@inject('contentOrganizerStore')
@observer
export class ContentOrganizerConfigPanel extends React.Component<IContentOrganizerConfigPanelProps, IContentOrganizerConfigPanelState> {

  private localizationService = new LocalizationService();

  constructor(props: IContentOrganizerConfigPanelProps) {
    super(props);
    this.state = {
      termsList: [],
      terms: undefined,
      documentLibraries: [],
      isLoading: true
    }

    TargetingService.getTermsAvailable(props.contentOrganizerStore.environment, props.contentOrganizerStore.tenant, props.contentOrganizerStore.token)
      .then((terms: ITermResult[]) => {
        let termsList = [];
        termsList.push({ key: undefined, value: "" });
        terms.forEach(term => {
          if (term.termSets && term.termSets.length > 0) {
            term.termSets.forEach(termSet => {
              termsList.push({ key: termSet.id, value: termSet.name });
            });
          }
        })
        this.setState({ terms, termsList });
      });
  }

  public componentDidMount() {
    this.getAvailableDocumentLibraries();
  }

  public componentWillReceiveProps(nextProps: IContentOrganizerConfigPanelProps): void {
    if (
      this.props.contentOrganizerStore.isEditMode &&
      nextProps.storeInitializationComplete != this.props.storeInitializationComplete &&
      nextProps.storeInitializationComplete == true
    ) {
      // When in edit mode, we wait for the store to fully initialization
      // to re-load available document libraries
      this.getAvailableDocumentLibraries();
    }
  }

  private mapDocumentLibraryOptionsToDocumentLibrary(options: IDocumentLibraryOption[]): IDocumentLibrary[] {
    return options.map(option => {
      return {
        title: option.title,
        url: option.url
      } as IDocumentLibrary
    });
  }

  private persistDocumentLibrariesToStore(options: IDocumentLibraryOption[]): void {
    this.props.contentOrganizerStore.documentLibraries = this.mapDocumentLibraryOptionsToDocumentLibrary(
      options.filter(option => option.selected)
    );
  }

  private getAvailableDocumentLibraries(): void {
    // Bail early if new or edit context
    if (this.props.contentOrganizerStore.newSiteCollection) {
      this.setState({ isLoading: false });
      return;
    }
    // Signal loading started
    this.setState({ isLoading: true }, () => {
      console.log("beforeIaReady");
      this.props.beforeIaReady();
    });
    // Load document libraries for a given site
    if (this.props.contentOrganizerStore.environment && this.props.contentOrganizerStore.token && this.props.contentOrganizerStore.tenant && this.props.contentOrganizerStore.siteCollectionAddress) {
      ContentOrganizerService.getSiteDocumentLibraries(this.props.contentOrganizerStore.environment, this.props.contentOrganizerStore.token, this.props.contentOrganizerStore.tenant, this.props.contentOrganizerStore.siteCollectionAddress).then((options: IDocumentLibraryOption[]) => {
        var provisoned = options.filter(option => option.selected);
        // Update state
        this.setState({ documentLibraries: options });
        // Add already provisioned doc libs to store
        this.persistDocumentLibrariesToStore(provisoned);
        // Signal loading finished
        this.setState({ isLoading: false }, () => {
          console.log("afterIaReady");
          this.props.afterIaReady();
        });
      });
    }
  }

  private getAvailableDocumentLibrariesAsDropDownOptions(): IMultiSelectDropDownOption[] {
    return this.state.documentLibraries?.map(option => {
      return {
        key: option.title,
        text: option.title,
        selected: option.selected
      } as IMultiSelectDropDownOption;
    }) ?? [];
  }

  private updateSelectionForDocumentLibraryOptions(dropDownOptions: IMultiSelectDropDownOption[]): void {
    const documentLibraries = this.state.documentLibraries?.map(option => {
      const dropDownOption = dropDownOptions.find(o => o.text == option.title);

      if (dropDownOption) {
        option.selected = dropDownOption.selected;
      }

      return option;
    });

    this.setState({ documentLibraries });
  }

  public render(): JSX.Element {
    const TemplateOptions = [
      { key: "Handbook", value: this.localizationService.strings.ContentOrganizer_Handbook },
      { key: "Basic", value: this.localizationService.strings.ContentOrganizer_BasicTemplate },
      { key: "NoTemplate", value: this.localizationService.strings.ContentOrganizer_NoTemplate },
    ];
    let panelAdd = (
      <div className={styles.IConfig_panel}>
        <div className={styles.IConfig_TitleContainer}>
          <div className={"IA_FontSize_24"}>
            {this.localizationService.strings.ContentOrganizer_ConfigSelect}
          </div>
          <div>
            <p className={"IA_FontSize_14"}>{this.localizationService.strings.ContentOrganizer_ConfigSelectDescription}</p>
          </div>
        </div>
        <div className={styles.IConfig_BodyContainer}>
          {/* <div>
            <IAToggle
              style={{ width: "100%", marginTop: "10px", marginBottom: "20px" }}
              label={this.localizationService.strings.ContentOrganizer_RequireContentApproval}
              checked={this.props.contentOrganizerStore.requireContentApproval}
              color={this.props.contentOrganizerStore.highlightColor}
              onChange={() => { this.props.contentOrganizerStore.requireContentApproval = !this.props.contentOrganizerStore.requireContentApproval }}
            />
            <div style={{ marginTop: "10px", display: this.props.contentOrganizerStore.requireContentApproval ? "block" : "none" }}>
              <p style={{ marginTop: "10px" }}>{this.localizationService.strings.ContentOrganizer_AddAproval}</p>
              <IAPeopleSearch
                token={this.props.contentOrganizerStore.token}
                tenant={this.props.contentOrganizerStore.tenant}
                environment={this.props.contentOrganizerStore.environment}
                multiSelection={true}
                selectedValues={this.props.contentOrganizerStore.approvalList}
                onSelect={(list: IUser[]) => {
                  this.props.contentOrganizerStore.approvalList = list;
                }}
                style={{ width: "500px" }}
              />
            </div>
          </div> */}
          <div style={{ marginTop: 30 }}>
            <div style={{ display: "block", clear: "both" }}>
              {this.props.contentOrganizerStore.isEditMode &&
                <IADropDown
                  options={TemplateOptions}
                  label={this.localizationService.strings.ContentOrganizer_SelectTemplate}
                  onChange={(option) => {
                    this.props.contentOrganizerStore.selectedTemplate = option;
                  }}
                  selectedOption={this.props.contentOrganizerStore.selectedTemplate}
                  style={{ width: "100%" }}
                />
              }
            </div>
            <div style={{ marginTop: "30px", display: "flex" }}>
              <IAToggle
                style={{
                  display: "inline-block",
                  marginRight: "10px",
                  width: "200px"
                }}
                label={this.localizationService.strings.ContentOrganizer_UseMetadata}
                checked={this.props.contentOrganizerStore.useMetadata}
                color={this.props.contentOrganizerStore.highlightColor}
                onChange={() => { this.props.contentOrganizerStore.useMetadata = !this.props.contentOrganizerStore.useMetadata }}
              />
              <IAToggle
                style={{
                  display: this.props.contentOrganizerStore.useMetadata ? "inline-block" : "none",
                  marginRight: "10px",
                  width: "350px",
                  clear: "none"
                }}
                label={this.localizationService.strings.ContentOrganizer_Required}
                checked={this.props.contentOrganizerStore.isUseMetadataRequired}
                color={this.props.contentOrganizerStore.highlightColor}
                onChange={() => { this.props.contentOrganizerStore.isUseMetadataRequired = !this.props.contentOrganizerStore.isUseMetadataRequired }}
              />
            </div>
            <div style={{ marginTop: "10px", display: "block" }}>
              {this.state.termsList.length > 0 && <IADropDown

                options={this.state.termsList}
                label={this.localizationService.strings.ContentOrganizer_SelectTerms}
                onChange={(option) => {
                  this.props.contentOrganizerStore.termSetId = option;
                }}
                selectedOption={this.props.contentOrganizerStore.termSetId}
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  width: "400px",
                  display: this.props.contentOrganizerStore.useMetadata ? "block" : "none"
                }}
              />
              }
            </div>
          </div>
          <div style={{ display: "flex", clear: "both", marginTop: 30 }}>
            <IAToggle
              style={{
                display: "inline-block",
                marginRight: "10px",
                width: "200px"
              }}
              label={this.localizationService.strings.ContentOrganizer_UseRevision}
              checked={this.props.contentOrganizerStore.useRevisionDate}
              color={this.props.contentOrganizerStore.highlightColor}
              onChange={() => { 
                this.props.contentOrganizerStore.useRevisionDate = !this.props.contentOrganizerStore.useRevisionDate;
                if(!this.props.contentOrganizerStore.useRevisionDate){
                  this.props.contentOrganizerStore.isUseRevisionDateRequired = false;              
                }
                this.props.contentOrganizerStore.revisioDateDays = 365;
               }}
            />
            <IAToggle
              style={{
                display: this.props.contentOrganizerStore.useRevisionDate ? "inline-block" : "none",
                marginRight: "10px",
                width: "200px",
                clear: "none"
              }}
              label={this.localizationService.strings.ContentOrganizer_Required}
              checked={this.props.contentOrganizerStore.isUseRevisionDateRequired}
              color={this.props.contentOrganizerStore.highlightColor}
              onChange={() => { this.props.contentOrganizerStore.isUseRevisionDateRequired = !this.props.contentOrganizerStore.isUseRevisionDateRequired }}
            />
            <IANumberField
              label={this.localizationService.strings.ContentOrganizer_RevisionDays}
              number={this.props.contentOrganizerStore.revisioDateDays}
              onChange={(revisioDateDays: number) => {
                if(revisioDateDays < 1){
                  revisioDateDays = 365;
                }
                this.props.contentOrganizerStore.revisioDateDays = revisioDateDays;
              }}
              styles={{
                width: "120px",
                marginTop: 0,
                display: this.props.contentOrganizerStore.useRevisionDate ? "block" : "none"
              }}
            />
          </div>
          <div style={{ display: "flex", clear: "both", marginTop: 30 }}>
            <IAToggle
              style={{
                display: "inline-block",
                marginRight: "10px",
                width: "200px"
              }}
              label={this.localizationService.strings.ContentOrganizer_UsePageResponsible}
              checked={this.props.contentOrganizerStore.usePageResponsible}
              color={this.props.contentOrganizerStore.highlightColor}
              onChange={() => { this.props.contentOrganizerStore.usePageResponsible = !this.props.contentOrganizerStore.usePageResponsible }}
            />
            <IAToggle
              style={{
                display: this.props.contentOrganizerStore.usePageResponsible ? "inline-block" : "none",
                marginRight: "10px",
                width: "350px",
                clear: "none"
              }}
              label={this.localizationService.strings.ContentOrganizer_Required}
              checked={this.props.contentOrganizerStore.isUsePageReesponsibleRequired}
              color={this.props.contentOrganizerStore.highlightColor}
              onChange={() => { this.props.contentOrganizerStore.isUsePageReesponsibleRequired = !this.props.contentOrganizerStore.isUsePageReesponsibleRequired }}
            />
          </div>
          {!this.props.contentOrganizerStore.newSiteCollection &&
            <div>
              <div style={{ display: "flex", clear: "both", marginTop: 30 }}>
                <IAMultiSelectDropDown
                  label={this.localizationService.strings.ContentOrganizer_ConfigDocumentLibraries}
                  placeholder={this.state.isLoading ? this.localizationService.strings.ContentOrganizer_ConfigLoadingDocumentLibraries : this.localizationService.strings.ContentOrganizer_ConfigSelectDocumentLibraries}
                  options={this.getAvailableDocumentLibrariesAsDropDownOptions()}
                  onSelectOptions={(dropDownOptions: IMultiSelectDropDownOption[]) => {
                    this.updateSelectionForDocumentLibraryOptions(dropDownOptions);
                    this.persistDocumentLibrariesToStore(this.state.documentLibraries.filter(x => x.selected));
                  }}
                />
              </div>
            </div>
          }
        </div>
        <div className={styles.IConfig_BodyContainerRight}>
          <div className={styles.IConfig_Img}>
            <img src={"https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/wizard3.svg"} />
          </div>
        </div>
      </div>);
    return this.state.isLoading ? <IASpinner color={this.props.contentOrganizerStore.highlightColor} /> : panelAdd;
  }

}